module.exports = __webpack_public_path__ + "img/adaptive-learning.3af583ea.svg";